import { EventAttributes } from '@/types'
import { UpdateEventMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditEventQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'

type Event = EditEventQuery['events']['nodes'][0]

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading
  } = useForm<UpdateEventMutation, EventAttributes, EditEventQuery, Event>({
    id,
    initializer: event => ({
      description: event.description,
      details: event.details,
      dateOut: event.dateOut,
      dateStart: event.dateStart,
      dateEnd: event.dateEnd,
      dateReturn: event.dateReturn,
      state: event.state,
      clientId: event.client.id,
      venueId: event.venue?.id,
      warehouseId: event.warehouse?.id
    }),
    query: EditQuery,
    queryKey: 'events',
    mutation: UpdateMutation,
    resultKey: 'updateEvent'
  })

  if (queryLoading) return <Loading />

  return (
    <>
      {queryError && <Error message={queryError} />}
      <div className="flex flex-col gap-6">
        {formBuilder.buildQueryError()}
        {formBuilder.buildField({ name: 'Client', field: 'clientId', type: 'client' })}
        {formBuilder.buildField({ name: 'Venue', field: 'venueId', type: 'venue' })}
        {formBuilder.buildField({ name: 'Warehouse', field: 'warehouseId', type: 'warehouse' })}
        {formBuilder.buildField({ name: 'Description', field: 'description', type: 'text' })}
        {formBuilder.buildField({ name: 'Details', field: 'details', type: 'textarea' })}
        <div className="grid grid-cols-2 gap-6">
          {formBuilder.buildField({ name: 'Date out', field: 'dateOut', type: 'datetime' })}
          {formBuilder.buildField({ name: 'Date start', field: 'dateStart', type: 'datetime' })}
          {formBuilder.buildField({ name: 'Date finish', field: 'dateEnd', type: 'datetime' })}
          {formBuilder.buildField({ name: 'Date return', field: 'dateReturn', type: 'datetime' })}
        </div>
        {formBuilder.saveButton(save, mutationLoading, saveSuccess)}
      </div>
    </>
  )
}
